/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* PRIVATE ROUTE: AUTHENTICATION
   ========================================================================== */

import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import ROUTES from 'routes/constant'
import { getFromLocalStorage } from 'utils/functions'
import { useMemo, useState, useEffect } from 'react'
import CryptoJS from 'crypto-js'

interface IAuthRouteProps {
  children: JSX.Element
  allowedRoles?: string[]
}

const AuthRoute = ({ children, allowedRoles }: IAuthRouteProps) => {
  const location = useLocation()
  const tokens = getFromLocalStorage<any>('tokens')
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()
  const userRole = tokens?.key
  let data
  if (userRole) {
    try {
      const giaiMa = CryptoJS.AES.decrypt(userRole, 'Access_Token_Secret_#$%_ExpressJS_Authentication')
      data = giaiMa.toString(CryptoJS.enc.Utf8)
    } catch (error) {
      console.error('Decryption error:', error)
    }
  }
  const isAuthenticated = useMemo(() => {
    return !!tokens?.accessToken
  }, [tokens?.accessToken])
  if (isAuthenticated && (location.pathname === ROUTES.login || location.pathname === ROUTES.signup)) {
    return <Navigate to={ROUTES.homePage} />
  }
  if (!isAuthenticated && location.pathname !== ROUTES.login && location.pathname !== ROUTES.signup && location.pathname !== ROUTES.forgotpassword) {
    return <Navigate to={ROUTES.login} />
  }
  if (allowedRoles && data && !allowedRoles.includes(data)) {
    return <Navigate to={ROUTES.notfound} />
  }

  return (
          <>
            {children}
          </>
  )
}
export default AuthRoute
